import cx from 'classnames'
import React, { FC } from 'react'

import css from './Title.module.scss'

interface ITitle {
  className?: string
  big?: boolean
  children: React.ReactNode
}

const Title: FC<ITitle> = ({ children, className, big }) => {
  return (
    <h1 className={cx('apoc', big && css.big, css.heading, className)}>
      {children}
    </h1>
  )
}

export default Title
